<template>
  <pui-dialog
    ref="dialog"
    :title="title"
    :showCloseButton="false"
    @outsideClick="onCancel"
    @close="onClose"
    transition="slide-up"
    class="folder-create-dialog folder-create-dialog__root"
  >
    <template #dialog-action>
      <div class="dialog-action">
        <pui-button
          @click="onCancel"
          class="folder-create-dialog__btn-cancel"
          variant="secondary"
          outline
        >
          {{ $t('dam.folders.create.cancel') }}
        </pui-button>
        <pui-button
          @click="createFolder"
          :disabled="!canCreate"
          class="folder-create-dialog__btn-create"
          variant="primary"
        >
          {{ $t('dam.folders.create.add') }}
        </pui-button>
      </div>
    </template>

    <template #default>
      <pui-common-spinner v-show="isCreating" fullscreen />

      <div
        v-for="language in languages"
        :key="language.itemId"
        class="folder-create-dialog__folder-lang-wrapper"
      >
        <pui-input
          :label="$t('dam.folders.create.name.label', { language: languageTranslate(language) })"
          :placeholder="$t('dam.folders.create.name.placeholder')"
          v-model="folderLanguageNames[language.identifier]"
          :name="`folder_name_${language.identifier}`"
          type="text"
          class="folder-create-dialog__folder-lang-name"
        ></pui-input>
      </div>

      <pui-group-panel
        :defaultClosed="true"
        :disabled="false"
        :title="$t('dam.folders.create.more_options')"
        v-permission="Permissions.Folders.CREATE_ADVANCED"
      >
        <pui-input
          :label="$t('dam.folders.create.alias.label')"
          :placeholder="$t('dam.folders.create.alias.placeholder')"
          v-model="alias"
          name="folder_alias"
          type="text"
          class="folder-create-dialog__folder-alias"
        ></pui-input>
      </pui-group-panel>
    </template>
  </pui-dialog>
</template>
<script>
import Vue from 'vue';

import services from '../../../../core/services';
import { LanguagesManagerService } from '../../../../core/services/languagesManagerService';
import Permissions from '../../constants/permissions';
import { getDamService } from '../../services';

export default {
  name: 'puiFolderCreateDialog',
  props: {},
  data() {
    return {
      languages: [],
      parentFolder: null,
      alias: '',
      /** Object map of language identifiers to value */
      folderLanguageNames: {},

      isCreating: false,
      Permissions,
    };
  },
  computed: {
    /**
     * @returns {string} the title of the dialog
     */
    title() {
      return this.parentFolder
        ? this.$t('dam.folders.actions.create_sub_folder')
        : this.$t('dam.folders.actions.create_root_folder');
    },
    /**
     * @returns {boolean} if the form is valid to create a folder
     */
    canCreate() {
      return !!this.languages.find(l => !!this.folderLanguageNames[l.identifier]);
    },
  },
  methods: {
    /**
     * @returns {string} the native label of the language object
     */
    languageTranslate(value) {
      return value.label[value.identifier] || '';
    },
    piivoTranslate(value) {
      return Vue.filter('piivoTranslate')(value);
    },
    /**
     * Opens the creation dialog
     *
     * @param {object} parentFolder - the parent in which to create the folder.
     * Set null to create a root folder
     */
    open(parentFolder) {
      this.languages = LanguagesManagerService.getLanguages();
      this.folderLanguageNames = {};
      this.parentFolder = parentFolder;

      if (this.$refs.dialog) {
        this.$refs.dialog.open();
      }
    },
    /**
     * Cancels the creation by closing the dialog
     */
    onCancel() {
      if (this.$refs.dialog) {
        this.$refs.dialog.close();
      }
    },
    /**
     * Resets dialog state
     */
    onClose() {
      this.alias = '';
      this.folderLanguageNames = {};
      this.parentFolder = null;
    },
    /**
     * Creates the folder
     */
    async createFolder() {
      this.isCreating = true;

      try {
        const parentId = this.parentFolder ? this.parentFolder.itemId : null;
        const res = await getDamService('foldersService').createFolder(
          'folderCreateDialog',
          { label: this.folderLanguageNames, alias: this.alias },
          parentId
        );
        const createdFolder = res.body;
        this.$emit('createdFolder', createdFolder, parentId);
      } catch (err) {
        services.getService('alerts').alertError(this.$t('dam.folders.create.create_error'));
      }

      this.isCreating = false;
      if (this.$refs.dialog) {
        this.$refs.dialog.close();
      }
      this.onClose();
    },
  },
};
</script>
